//时间转换工具包

//封装Date对象的Format方法
Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

//毫秒数转换成特定的时间格式（例如：yyyy/MM/dd hh:mm:ss）的公用方法
function msecToSpecificTime (msec, formatType){ 
  let itemDate = '';

  if(msec){
    itemDate = new Date(msec*1000).Format(formatType);
  }

  return itemDate;
}
 
// 出参
export default {
  getMsecToSpecificTime: function (curMsec, curFormatType) {
    return msecToSpecificTime(curMsec, curFormatType);
  }
}


// WEBPACK FOOTER //
// ./src/utils/formatTime.js